import apiClient from '../utils/apiClient';

export interface PlanCommissionScheme {
  mode: 'flat' | 'tiers' | 'fixed' | 'fixed-tiers' | 'discount';
  percent?: number;
  tiers?: Array<{ upTo: number | null; percent: number }>;
  fixedAmount?: number;
  fixedTiers?: Array<{ upTo: number | null; amount: number }>;
  /** mode='discount': این درصد از «هر» نرخ پایهٔ فعال کم می‌شود (داینامیک) */
  discountPercent?: number;
}

export interface SellerPlan {
  _id: string;
  name: string;
  description?: string;
  price: number;
  durationDays: number;
  commissionScheme: PlanCommissionScheme;
  discountQuota: number | null;
  features: string[];
  isActive: boolean;
  sortOrder: number;
  activeSubscribers?: number;
  createdAt?: string;
}

export type SellerPlanPayload = Omit<SellerPlan, '_id' | 'activeSubscribers' | 'createdAt'>;

class SellerPlanService {
  async getPlans(): Promise<SellerPlan[]> {
    const res = await apiClient.get('/admin/seller-plans');
    if (res.data.success) return res.data.data;
    throw new Error(res.data.message || 'خطا در دریافت پلن‌ها');
  }

  async createPlan(payload: SellerPlanPayload): Promise<SellerPlan> {
    const res = await apiClient.post('/admin/seller-plans', payload);
    if (res.data.success) return res.data.data;
    throw new Error(res.data.message || 'خطا در ایجاد پلن');
  }

  async updatePlan(id: string, payload: SellerPlanPayload): Promise<SellerPlan> {
    const res = await apiClient.patch(`/admin/seller-plans/${id}`, payload);
    if (res.data.success) return res.data.data;
    throw new Error(res.data.message || 'خطا در ویرایش پلن');
  }

  async deactivatePlan(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/seller-plans/${id}`);
    if (!res.data.success) throw new Error(res.data.message || 'خطا در غیرفعال‌سازی پلن');
  }
}

export default new SellerPlanService();
